import { isStitchedMicrofrontendPath } from './microfrontend-routing';

export function normalizeSpaPath(path: string): string {
  if (!path) return '/';
  const [pathname, query = ''] = path.split('?');
  const trimmedPath = pathname.replace(/\/+$/, '') || '/';
  return query ? `${trimmedPath}?${query}` : trimmedPath;
}

export function navigateWithinSpa(path: string, options?: { replace?: boolean }): void {
  if (typeof window === 'undefined') return;

  const nextPath = normalizeSpaPath(path);
  const targetPathname = nextPath.split('?')[0] ?? '/';

  if (isStitchedMicrofrontendPath(targetPathname)) {
    window.location.assign(nextPath);
    return;
  }

  const current = `${window.location.pathname}${window.location.search}`;
  if (current === nextPath) return;

  if (options?.replace) {
    window.history.replaceState({}, '', nextPath);
  } else {
    window.history.pushState({}, '', nextPath);
  }

  window.dispatchEvent(new PopStateEvent('popstate'));
}
